import { NgModule, inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateRouteGuard } from '@core/guards/can-activate-route.guard';
import { LogGuard } from '@core/guards/log.guard';
import { IsEncryption } from '@core/services/isEncryption';
import { DashboardService } from '@page/dashboard/helper/dashboard.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { LayoutComponent } from './layout/layout.component';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/dashboard',
    
  },
  { path: 'maintenance', loadComponent: () => import('./pages/maintenance/maintenance.component').then(c => c.MaintenanceComponent) },
  // {
  //   path: 'test',
  //   loadComponent: () => import('./core/custome-modal/data-table/data-table.component').then(c => c.DataTableComponent)
  // },
  // {
  //   path: 'test1',
  //   loadComponent: () => import('./pages/testing/testing.component').then(c => c.TestingComponent)
  // },
  {
    path: '',
    resolve: [IsEncryption],
    children: [
      {
        path: 'auth',
        canActivate: [LogGuard],
        loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule)
      },
      {
        path: '',
        component: LayoutComponent,
        canActivate: [CanActivateRouteGuard],
        children: [
          {
            path: '',
            resolve: {
              kycStatus: async () => await firstValueFrom(forkJoin([inject(DashboardService).getKycStatus()]))
            },
            loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule)
          },
          {
            path: '**',
            loadComponent: () => import('src/app/pages/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
          }
        ],
      },
    ]
  },

  {
    path: 'page-not-found',
    loadComponent: () => import('./pages/page-not-found/page-not-found.component').then(c => c.PageNotFoundComponent)
  },
  {
    path: '**',
    redirectTo: '/page-not-found',
  }
];



@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule { }
